import React from 'react';
import { Select } from '@kido/ui';
var w = {
    'w-0': ['2019-12-30', '2020-01-05'],
    'w-1': ['2020-01-06', '2020-01-12'],
    'w-2': ['2020-01-13', '2020-01-19'],
    'w-3': ['2020-01-20', '2020-01-26'],
    'w-4': ['2020-01-27', '2020-02-02'],
    'w-5': ['2020-02-03', '2020-02-09'],
    'w-6': ['2020-02-10', '2020-02-16'],
    'w-7': ['2020-02-17', '2020-02-23'],
    'w-9': ['2020-02-24', '2020-03-01'],
    'w-10': ['2020-03-02', '2020-03-08'],
    'w-11': ['2020-03-09', '2020-03-15'],
    'w-12': ['2020-03-16', '2020-03-22'],
    'w-13': ['2020-03-23', '2020-03-29'],
    'w-14': ['2020-03-30', '2020-04-05'],
    'w-15': ['2020-04-06', '2020-04-12'],
    'w-16': ['2020-04-13', '2020-04-19'],
    'w-17': ['2020-04-20', '2020-04-26'],
    'w-18': ['2020-04-27', '2020-05-03'],
    'w-19': ['2020-05-04', '2020-05-10'],
    'w-20': ['2020-05-11', '2020-05-17'],
    'w-21': ['2020-05-18', '2020-05-24'],
    'w-22': ['2020-05-25', '2020-05-31'],
    'w-23': ['2020-06-01', '2020-06-07'],
    'w-24': ['2020-06-08', '2020-06-14'],
    'w-25': ['2020-06-15', '2020-06-21'],
    'w-26': ['2020-06-22', '2020-06-28'],
    'w-27': ['2020-06-29', '2020-07-05'],
    'w-28': ['2020-07-06', '2020-07-12'],
    'w-29': ['2020-07-13', '2020-07-19'],
    'w-30': ['2020-07-20', '2020-07-26'],
    'w-31': ['2020-07-27', '2020-08-02'],
    'w-32': ['2020-08-03', '2020-08-09'],
    'w-33': ['2020-08-10', '2020-08-16'],
    'w-34': ['2020-08-17', '2020-08-23'],
    'w-35': ['2020-08-24', '2020-08-30'],
    'w-36': ['2020-08-31', '2020-09-06'],
    'w-37': ['2020-09-07', '2020-09-13'],
    'w-38': ['2020-09-14', '2020-09-20'],
    'w-39': ['2020-09-21', '2020-09-27'],
    'w-40': ['2020-09-28', '2020-10-04'],
    'w-41': ['2020-10-05', '2020-10-11'],
    'w-42': ['2020-10-12', '2020-10-28'],
    'w-43': ['2020-10-19', '2020-10-25'],
    'w-44': ['2020-10-26', '2020-11-01'],
    'w-45': ['2020-11-02', '2020-11-08'],
    'w-46': ['2020-11-09', '2020-11-15'],
    'w-47': ['2020-11-16', '2020-11-22'],
    'w-48': ['2020-11-23', '2020-11-29'],
    'w-49': ['2020-11-30', '2020-12-06'],
    'w-50': ['2020-12-07', '2020-12-13'],
    'w-51': ['2020-12-14', '2020-12-20'],
    'w-52': ['2020-12-21', '2020-12-27'],
    'w-53': ['2020-12-28', '2021-01-03']
};
var Week = function (_a) {
    var theme = _a.theme, onChange = _a.onChange;
    return (React.createElement(Select, { mode: theme.mode, options: Object.keys(w).map(function (d) {
            return {
                label: w[d][0] + " / " + w[d][1],
                id: w[d]
            };
        }), onChange: onChange, placeholder: "Select a week" }));
};
export default Week;
